import { ASSET_BASE_URL } from "../../contexts/constants";

export const NEW_DASHBOARD_IMAGE = {
  src: `${ASSET_BASE_URL}/static/reporting/new-dashboard.png`,
  alt: "New Dashboard Image",
  title: "This dashboard is empty",
  subtitle: "Get started by adding your first visualization",
};
